import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";

const ITEMS = [
  { title: "IV Therapy", desc: "Hydration and targeted nutrient support designed around your wellness goals.", image: "https://restorergv.com/wp-content/uploads/2024/09/iv-therapy-2-1024x819.jpg", to: "/iv-therapy" },
  { title: "Wellness Consultations", desc: "Meet with Steve or Lilly to discuss your health, goals, and recommended wellness options.", image: "https://images.pexels.com/photos/8460095/pexels-photo-8460095.jpeg", to: "/book/consult" },
  { title: "Peptide Wellness", desc: "Educational information about peptide-focused wellness services and consultation options.", image: "https://restorergv.com/wp-content/uploads/2023/03/peptide-therapy-1.jpg", to: "/book/consult?type=peptide" },
  { title: "Vitamins & Supplements", desc: "Professional-quality wellness products, curated to support real results.", image: "https://images.unsplash.com/photo-1627467959547-8e44da7aa00a?w=1000", to: "/shop" },
  { title: "Memberships", desc: "Make IV therapy part of your routine with our monthly membership options.", image: "https://restorergv.com/wp-content/uploads/2024/11/1-1024x552.jpg", to: "/memberships" },
];

export default function Services() {
  return (
    <div data-testid="services-page">
      <section className="section-y pb-10">
        <div className="container-x max-w-3xl">
          <div className="overline">Services</div>
          <h1 className="font-display text-5xl lg:text-6xl text-sage-800 mt-4 text-balance">Personalized care, designed around how you actually want to feel.</h1>
          <p className="mt-6 text-lg text-sage-800/70">Every service at Restore Wellness is built on the belief that feeling your best shouldn't come from a one-size-fits-all approach.</p>
        </div>
      </section>
      <section className="pb-24">
        <div className="container-x space-y-14">
          {ITEMS.map((s, i) => (
            <div key={s.title} data-testid={`service-item-${i}`} className={`grid lg:grid-cols-2 gap-8 lg:gap-14 items-center ${i%2===1?'lg:[&>div:first-child]:order-2':''}`}>
              <div className="rounded-3xl overflow-hidden aspect-[4/3] bg-sand-100">
                <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
              </div>
              <div className="px-1">
                <div className="overline">0{i+1}</div>
                <h2 className="font-display text-3xl lg:text-4xl text-sage-800 mt-3">{s.title}</h2>
                <p className="mt-4 text-sage-800/70 leading-relaxed max-w-md">{s.desc}</p>
                <Button asChild className="btn-pill h-11 mt-7 bg-sage-700 hover:bg-sage-800 text-white">
                  <Link to={s.to}>Explore {s.title} <ArrowUpRight className="w-4 h-4 ml-1" /></Link>
                </Button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
